<script setup lang="ts">
import router from '@/router'
</script>
<template>
  <div class="flex items-center justify-center w-full">
    <el-result icon="warning" title="404提示" sub-title="你找的页面走丢了~">
      <template #extra>
        <el-button type="primary" @click="router.push('/')">回到首页</el-button>
      </template>
    </el-result>
  </div>
</template>
<style scoped lang="scss"></style>
